<template>
  <div id="smsRecord">
    <div class="yto-box">
      <el-form :inline="true" :model="form" ref="ruleForm">
        <el-form-item class="data-picker" label="发送时间">
          <el-date-picker
            v-model="form.dateTime"
            type="daterange"
            @change="changeDate"
            :picker-options="pickerOptions"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="短信类型" prop="messageType">
          <el-select v-model="form.smsType" placeholder="请选择">
            <el-option
              v-for="item in messageTypeOptions"
              :key="item.smsCode"
              :label="item.smsName"
              :value="item.smsCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发送状态" prop="messageStatus">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option
              v-for="item in messageStatusOptions"
              :key="item.statusCode"
              :label="item.statusName"
              :value="item.statusCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-r" label>
          <el-button type="primary" @click="queryTableData" style="width:80px;">查询</el-button>
          <el-button @click="resetForm('ruleForm')" plain style="width:80px;">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="yto-table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="#" align="center" type="index" width="180">
          <template
            slot-scope="scope"
          >{{page ? page.limit * (page.pageNo - 1) + scope.$index + 1 : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="smsType" label="短信类型" align="left"></el-table-column>
        <el-table-column prop="mailNo" label="运单号" align="left"></el-table-column>
        <el-table-column prop="receiveName" label="收件人" align="left"></el-table-column>
        <el-table-column prop="receivePhone" label="手机号" align="left"></el-table-column>
        <el-table-column prop="status" label="发送状态" align="left"></el-table-column>
        <el-table-column prop="createTime" label="发送时间" align="left"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="page.sizes"
        :page-size="page.limit"
        layout="total, sizes, prev, pager, next"
        :total="page.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import netAPI from '@/api';
import { dateFormat } from '../../utils/util';
export default {
  name: 'smsRecord',
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  data() {
    return {
      messageTypeOptions: [
        {
          smsCode: '',
          smsName: '全部'
        },
        {
          smsCode: '1',
          smsName: '发货短信'
        },
        {
          smsCode: '2',
          smsName: '催评短信'
        },
        {
          smsCode: '3',
          smsName: 'AI物流预警'
        }
      ],
      messageStatusOptions: [
        {
          statusCode: '',
          statusName: '全部'
        },
        {
          statusCode: '1',
          statusName: '发送成功'
        },
        {
          statusCode: '2',
          statusName: '发送失败'
        }
      ],
      form: {
        dateTime: [],
        startTime: '',
        endTime: '',
        smsType: '',
        status: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().getTime();
        }
      },
      tableData: [],
      page: {
        pageNo: 1,
        limit: 20,
        sizes: [20, 50, 100],
        total: 0
      }
    };
  },
  created() {
    this.initTime();
    this.queryTableData();
  },
  methods: {
    handleSizeChange(val) {
      this.page.limit = val;
      this.getSmsRecordList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getSmsRecordList();
    },
    changeDate(val) {
      // 设置一年以后时间
      let addTime = new Date(val[0]).getTime() + 365 * 24 * 3600 * 1000;
      if (addTime < new Date(val[1]).getTime()) {
        this.$message.warning('时间最多选择365天');
        this.form.dateTime = [];
        this.form.dateTime.push(val[0]);
        this.form.dateTime.push(dateFormat(new Date(addTime), 'yyyy-MM-dd'));
      }
      this.form.startTime = this.form.dateTime[0];
      this.form.endTime = this.form.dateTime[1];
    },
    // 表格数据查询
    queryTableData() {
      this.page.pageNo = 1;
      this.getSmsRecordList();
    },
    getSmsRecordList() {
      let params = {
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        userId: this.userMess.loginId, // 登录id
        smsType: this.form.smsType,
        status: this.form.status,
        pageNo: this.page.pageNo,
        pageSize: this.page.limit
      };
      netAPI.getSmsRecordList(params).then(res => {
        if (res.success) {
          this.page.total = res.total;
          this.tableData = res.rows;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.page.pageNo = 1;
      this.form.status = '';
      this.form.smsType = '';
      if (formName === 'ruleForm') {
        this.initTime(); // 初始化搜索条件中的时间
      }
    },
    // 初始化时间
    initTime() {
      this.form.dateTime = [];
      let monthTime = new Date(new Date().getTime());
      let startTime = dateFormat(monthTime, 'yyyy-MM') + '-01';
      let endTime = dateFormat(monthTime, 'yyyy-MM-dd');
      this.form.dateTime.push(startTime);
      this.form.dateTime.push(endTime);
      this.form.startTime = startTime;
      this.form.endTime = endTime;
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
#smsRecord {
  .yto-box {
    padding: 20px 0 0 0;
    .data-picker {
      .el-date-editor--daterange.el-input__inner {
        width: 220px;
      }
    }
  }

  .btn-r {
    position: absolute;
    right: 95px;
    width: auto !important;
  }
}
</style>
